import { render, staticRenderFns } from "./CollapseTaskBtn.vue?vue&type=template&id=261c3e47&"
import script from "./CollapseTaskBtn.vue?vue&type=script&lang=js&"
export * from "./CollapseTaskBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports